export const allTagsSelector = (state) => state.tags.allTags;
